import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const prepartum: ImportTypeConfig = {
  type: 'prepartum',
}
